import { getCostIndex, costRecordCancelDialog } from '@/services/costMaintain'
import i18n from '@/lib/language'
const costIndexColumns = [
  {
    title: i18n.t('message["1257"]'),
    dataIndex: 'maintainContent',
    key: 'maintainContent'
  },
  {
    title: i18n.t('message["288"]'),
    dataIndex: 'maintainFrom',
    key: 'maintainFrom'
  },
  {
    title: i18n.t('message["1428"]'),
    dataIndex: 'inquirynum',
    key: 'inquirynum'
  },
  {
    title: i18n.t('message["1138"]'),
    key: 'realinquirynum',
    dataIndex: 'realinquirynum'
  },
  {
    title: i18n.t('message["623"]'),
    key: 'netCost',
    dataIndex: 'netCost'
  },
  {
    title: i18n.t('message["1426"]'),
    key: 'grossCostPreInquiry',
    dataIndex: 'grossCostPreInquiry'
  }
]
export default {
  namespaced: true,
  state: {
    costIndexColumns, // 成本维护首页table表头数据
    costIndexData: [], // 首页数据
    messageSourceList: [], // 信息来源数据
    loadingContent: true // 加载动画
  },
  mutations: {
    // 设置成本维护首页数据
    setCostIndexData (state, data) {
      state.costIndexData = data
    },
    setLoadingContent (state, data) {
      state.loadingContent = data
    }
  },
  actions: {
    // 获取成本维护首页数据方法
    async fetchGetCostIndex ({ commit }) {
      commit('setLoadingContent', true)
      const chain = await getCostIndex()
        .onSuccess(payload => {
          commit('setCostIndexData', payload)
          commit('setLoadingContent', false)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 取消弹框
    async cacelCostDialog ({ commit }) {
      const chain = await costRecordCancelDialog()
        .onSuccess(res => {
          console.log(res)
        })
        .config({ tip: false })
        .fetch()
      return chain
    }
  }
}
